import React from 'react'
import PropTypes from 'prop-types'
import './_details-sections.scss'

function DetailsSections({ title, items }) {
  return (
    <article className="details-sections">
      {title && <h2 className="details-sections__title">{title}</h2>}
      <div className="details-sections__items">
        {items?.map(item => (
          <div className="details-sections__item" key={item.title + item.copy}>
            {item.title && <h3 className="details-sections__item-title">{item.title}</h3>}
            {item.copy && <p className="details-sections__item-copy">{item.copy}</p>}
          </div>
        ))}
      </div>
    </article>
  )
}

DetailsSections.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  })).isRequired,
}

export default DetailsSections
